// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2P67d","detailsBorder":"styles_detailsBorder__1ghOD"};